import { FC } from 'react';

import LockIcon from '@mui/icons-material/Lock';
import PersonIcon from '@mui/icons-material/Person';
import Divider from '@mui/material/Divider';
import ListItemIcon from '@mui/material/ListItemIcon';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Link from '@mui/material/Link';
import UserMenuLogout from 'components/UserMenuLogout';

type Props = {
  anchorEl: HTMLElement | null;
  onClose: () => void;
};

const UserMenu: FC<Props> = ({ anchorEl, onClose }) => (
  <Menu
    anchorEl={anchorEl}
    open={Boolean(anchorEl)}
    onClose={onClose}
    PaperProps={{
      elevation: 0,
      sx: {
        overflow: 'visible',
        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
        mt: 1.5,
        '& .MuiAvatar-root': {
          width: 32,
          height: 32,
          ml: -0.5,
          mr: 1,
        },
        '&:before': {
          content: '""',
          display: 'block',
          position: 'absolute',
          top: 0,
          right: 14,
          width: 10,
          height: 10,
          bgcolor: 'background.paper',
          transform: 'translateY(-50%) rotate(45deg)',
          zIndex: 0,
        },
      },
    }}
    transformOrigin={{ horizontal: 'right', vertical: 'top' }}
    anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}>
    <MenuItem href="/account/profile" component={Link}>
      <ListItemIcon>
        <PersonIcon />
      </ListItemIcon>{' '}
      Profilis
    </MenuItem>

    <MenuItem href="/account/password" component={Link}>
      <ListItemIcon>
        <LockIcon />
      </ListItemIcon>{' '}
      Keisti slaptažodį
    </MenuItem>

    <Divider />

    <UserMenuLogout />
  </Menu>
);

export default UserMenu;
